import React from 'react';
import { useGestureNavigation } from './hooks/useGestureNavigation';

const GestureHandler = ({ children, isPanelOpen, onOpen, onClose }) => {
  const handlers = useGestureNavigation({
    isOpen: isPanelOpen,
    onOpen,
    onClose,
  });

  return (
    <div className="mobile-gesture-surface" {...handlers}>
      {children}
    </div>
  );
};

export default GestureHandler;
